// API related actions
export const FETCHING_PARTS_LIST = '@@toyota/FETCHING_PARTS_LIST';
export const FETCHED_PARTS_LIST = '@@toyota/FETCHED_PARTS_LIST';
export const FETCHED_PARTS_LIST_FAILED = '@@toyota/FETCHED_PARTS_LIST_FAILED';
export const DOWNLOADING_PARTS_LIST = '@@toyota/DOWNLOADING_PARTS_LIST';
export const DOWNLOADED_PARTS_LIST = '@@toyota/DOWNLOADED_PARTS_LIST';
export const DOWNLOADED_PARTS_LIST_FAILED = '@@toyota/DOWNLOADED_PARTS_LIST_FAILED';
export const FETCHING_PART = '@@toyota/FETCHING_PART';
export const FETCHED_PART = '@@toyota/FETCHED_PART';
export const FETCHED_PART_FAILED = '@@toyota/FETCHED_PART_FAILED';
export const FETCHING_KARDEX = '@@toyota/FETCHING_KARDEX';
export const FETCHED_KARDEX = '@@toyota/FETCHED_KARDEX';
export const FETCHED_KARDEX_FAILED = '@@toyota/FETCHED_KARDEX_FAILED';
export const DOWNLOADING_KARDEX = '@@toyota/DOWNLOADING_KARDEX';
export const DOWNLOADED_KARDEX = '@@toyota/DOWNLOADED_KARDEX';
export const DOWNLOADED_KARDEX_FAILED = '@@toyota/DOWNLOADED_KARDEX_FAILED';
export const FETCHING_ANALYSIS_LIST = '@@toyota/FETCHING_ANALYSIS_LIST';
export const FETCHED_ANALYSIS_LIST = '@@toyota/FETCHED_ANALYSIS_LIST';
export const FETCHED_ANALYSIS_LIST_FAILED = '@@toyota/FETCHED_ANALYSIS_LIST_FAILED';
export const FETCHING_ANALYSIS = '@@toyota/FETCHING_ANALYSIS';
export const FETCHED_ANALYSIS = '@@toyota/FETCHED_ANALYSIS';
export const FETCHED_ANALYSIS_FAILED = '@@toyota/FETCHED_ANALYSIS_FAILED';
export const SAVING_ANALYSIS = '@@toyota/SAVING_ANALYSIS';
export const SAVED_ANALYSIS = '@@toyota/SAVED_ANALYSIS';
export const SAVED_ANALYSIS_FAILED = '@@toyota/SAVED_ANALYSIS_FAILED';
export const FETCHING_WEEKLY_ANALYSIS = '@@toyota/FETCHING_WEEKLY_ANALYSIS';
export const FETCHED_WEEKLY_ANALYSIS = '@@toyota/FETCHED_WEEKLY_ANALYSIS';
export const FETCHED_WEEKLY_ANALYSIS_FAILED = '@@toyota/FETCHED_WEEKLY_ANALYSIS_FAILED';
export const GET_PART_WEEKLY_MOVES_REQUEST = '@@toyota/GET_PART_WEEKLY_MOVES_REQUEST';
export const GET_PART_WEEKLY_MOVES_SUCCESS = '@@toyota/GET_PART_WEEKLY_MOVES_SUCCESS';
export const GET_PART_WEEKLY_MOVES_FAILED = '@@toyota/GET_PART_WEEKLY_MOVES_FAILED';

// Modal actions
export const FETCHING_TDE_STOCK_DETAIL = '@@toyota/FETCHING_TDE_STOCK_DETAIL';
export const FETCHED_TDE_STOCK_DETAIL = '@@toyota/FETCHED_TDE_STOCK_DETAIL';
export const FETCHED_TDE_STOCK_DETAIL_FAILED = '@@toyota/FETCHED_TDE_STOCK_DETAIL_FAILED';
export const FETCHING_STOCK_DETAIL = '@@toyota/FETCHING_STOCK_DETAIL';
export const FETCHED_STOCK_DETAIL = '@@toyota/FETCHED_STOCK_DETAIL';
export const FETCHED_STOCK_DETAIL_FAILED = '@@toyota/FETCHED_STOCK_DETAIL_FAILED';
export const FETCHING_BACK_ORDERS_DETAIL = '@@toyota/FETCHING_BACK_ORDERS_DETAIL';
export const FETCHED_BACK_ORDERS_DETAIL = '@@toyota/FETCHED_BACK_ORDERS_DETAIL';
export const FETCHED_BACK_ORDERS_DETAIL_FAILED = '@@toyota/FETCHED_BACK_ORDERS_DETAIL_FAILED';
export const FETCHING_ON_ORDERS_DETAIL = '@@toyota/FETCHING_ON_ORDERS_DETAIL';
export const FETCHED_ON_ORDERS_DETAIL = '@@toyota/FETCHED_ON_ORDERS_DETAIL';
export const FETCHED_ON_ORDERS_DETAIL_FAILED = '@@toyota/FETCHED_ON_ORDERS_DETAIL_FAILED';
export const FETCHING_WAREHOUSE_STOCK_DETAIL = '@@toyota/FETCHING_WAREHOUSE_STOCK_DETAIL';
export const FETCHED_WAREHOUSE_STOCK_DETAIL = '@@toyota/FETCHED_WAREHOUSE_STOCK_DETAIL';
export const FETCHED_WAREHOUSE_STOCK_DETAIL_FAILED =
'@@toyota/FETCHED_WAREHOUSE_STOCK_DETAIL_FAILED';
export const FETCHING_BINNING_PENDING_DETAIL = '@@toyota/FETCHING_BINNING_PENDING_DETAIL';
export const FETCHED_BINNING_PENDING_DETAIL = '@@toyota/FETCHED_BINNING_PENDING_DETAIL';
export const FETCHED_BINNING_PENDING_DETAIL_FAILED =
'@@toyota/FETCHED_BINNING_PENDING_DETAIL_FAILED';
export const FETCHING_INVOICES_CONFIRMED_DETAIL = '@@toyota/FETCHING_INVOICES_CONFIRMED_DETAIL';
export const FETCHED_INVOICES_CONFIRMED_DETAIL = '@@toyota/FETCHED_INVOICES_CONFIRMED_DETAIL';
export const FETCHED_INVOICES_CONFIRMED_DETAIL_FAILED =
'@@toyota/FETCHED_INVOICES_CONFIRMED_DETAIL_FAILED';
export const GET_PART_STOCK_RESERVATIONS_REQUEST = '@@toyota/GET_PART_STOCK_RESERVATIONS_REQUEST';
export const GET_PART_STOCK_RESERVATIONS_SUCCESS = '@@toyota/GET_PART_STOCK_RESERVATIONS_SUCCESS';
export const GET_PART_STOCK_RESERVATIONS_FAILED = '@@toyota/GET_PART_STOCK_RESERVATIONS_FAILED';
export const FETCHING_RESERVE_DETAIL = '@@toyota/FETCHING_RESERVE_DETAIL';
export const FETCHED_RESERVE_DETAIL = '@@toyota/FETCHED_RESERVE_DETAIL';
export const FETCHED_RESERVE_DETAIL_FAILED = '@@toyota/FETCHED_RESERVE_DETAIL_FAILED';

// complementary actions
export const CHANGE_CODE_TEXT_FILTER = '@@toyota/CHANGE_CODE_TEXT_FILTER';
export const CHANGE_DESCRIPTION_TEXT_FILTER = '@@toyota/CHANGE_DESCRIPTION_TEXT_FILTER';
export const CHANGE_MOTOR_TEXT_FILTER = '@@toyota/CHANGE_MOTOR_TEXT_FILTER';
export const CHANGE_BRAND_TEXT_FILTER = '@@toyota/CHANGE_BRAND_TEXT_FILTER';
export const CHANGE_LOCATION_TEXT_FILTER = '@@toyota/CHANGE_LOCATION_TEXT_FILTER';
export const CHANGE_CLASSIFICATION_TEXT_FILTER = '@@toyota/CHANGE_CLASSIFICATION_TEXT_FILTER';
export const CHANGE_ORIGIN_TEXT_FILTER = '@@toyota/CHANGE_ORIGIN_TEXT_FILTER';
export const CHANGE_PARTS_LIST_PAGE = '@@toyota/CHANGE_PARTS_LIST_PAGE';
export const CHANGE_PARTS_LIST_PAGE_SIZE = '@@toyota/CHANGE_PARTS_LIST_PAGE_SIZE';
export const CLEAR_FILTERS = '@@toyota/CLEAR_FILTERS';
export const GENERATING_DATA_SHEET = '@@toyota/GENERATING_DATA_SHEET';
export const GENERATED_DATA_SHEET = '@@toyota/GENERATED_DATA_SHEET';
export const GENERATED_DATA_SHEET_FAILED = '@@toyota/GENERATED_DATA_SHEET_FAILED';
export const CLEAR_DATA_SHEET_URL = '@@toyota/CLEAR_DATA_SHEET_URL';

// search codes without labels list
export const FETCHING_PRINT_PART_LIST = '@@toyota/FETCHING_PRINT_PART_LIST';
export const FETCHED_PRINT_PART_LIST = '@@toyota/FETCHED_PRINT_PART_LIST';
export const FETCHED_PRINT_PART_LIST_FAILED = '@@toyota/FETCHED_PRINT_PART_LIST_FAILED';
export const CLEAR_PRINT_PART_LIST_FAILED = '@@toyota/CLEAR_PRINT_PART_LIST_FAILED';
